<template>
  <div>
    <div class="title"><h3 style="margin: 20px 0 0 0;">完成率统计</h3></div>
    <div class="drawPie" id="main" style="width:248px; height:220px;margin: 0;">

    </div>
    <div class="taskList" style="width:248px ;height:300px; margin-top:25px;">
      <el-row>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>完成率统计</span>
          </div>
          <div v-for="o in 4" :key="o" class="text item">
            {{'列表内容 ' + o }}
          </div>
        </el-card>
      </el-row>
      <el-row>
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <span>里程碑</span>
          </div>
          <div v-for="o in 4" :key="o" class="text item">
            {{'列表内容 ' + o }}
          </div>
        </el-card>
      </el-row>
    </div>
    
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: 'index',
  data() {
    return {
      
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getPie()
    })
  },
  methods: {
    getPie() {
      // 绘制图表
      var myChart = echarts.init(document.getElementById('main'))
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 1048, name: 'Search Engine' },
              { value: 735, name: 'Direct' },
              { value: 580, name: 'Email' },
              { value: 484, name: 'Union Ads' },
              { value: 300, name: 'Video Ads' }
            ]
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    }
  }

}
</script>

<style scoped>
 .text {
    font-size: 14px;
  }

  .title {
    font-size: 14px;
    font-weight: 700;
    position: relative;
    color: #2e405e;
    padding-left: 20px;
    margin: 0;
  }

  .item {
    margin-bottom: 3px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 240px;
  }
</style>